export const CHART_CONSTANTS = {
  xLabelSpacingHours: 4,
  xNowModeLabelSpacingSeconds: 30,
  xAxisLabelsCount: 12,
  xAxisTimeFormat: 'ha',
  xAxisNowModeTimeFormat: 'HH:mm:ss',
  yTicksCountPerSide: 2,
  yGridLinesPerSide: 4,
  fallbackYDomain: [-100, 100],
  hoursInStandardDay: 24,
};
